<template>
  <div class="pardata_box">
    <h3 class="margin">案件详细进度<span style="margin-left:30px" v-if="Rescuecompany != null && Rescuecompany != ''">救援公司：{{ Rescuecompany }}</span></h3>
    <el-table empty-text="暂无数据" :data="tableData" border :row-key="getRowKeys" :expand-row-keys="expands"
      @current-change="toggleRowExpansion">
      <el-table-column type="expand">
        <template slot-scope="props" v-if="props.row.dict.chkPt == 140 && props.$index == tableData.length - 1">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item>
              <div v-for="item in getBjLise" class="baojia">
                <ul>
                  <li>{{item.insti.name}}</li>
                  <li>整体报价:{{item.solution.totalFee}} {{item.solution.currency}}</li>
                  <li>救援费用:{{item.solution.rescueFee}} {{item.solution.currency}}</li>
                  <li>医疗费用:{{item.solution.medicFee}} {{item.solution.currency}}</li>
                  <li>案件服务费用:{{item.solution.caseFee}} {{item.solution.currency}}</li>
                  <li v-if="props.row.dict.chkPt == 140 && item.solution.state == 0">等待报价</li>
                  <li v-if="props.row.dict.chkPt == 140 && item.solution.state == 1">已报价</li>
                  <li v-if="item.solution.state == 3">已关闭</li>
                  <li v-if="props.row.dict.chkPt == 150 && item.solution.state == 2">(费用等待审核)</li>
                  <li v-if="props.row.dict.chkPt == 160 && item.solution.state == 2">(费用审核通过)</li>
                  <li class="link" @click="pass(props.row.caseid, v)" v-if="props.row.dict.chkPt == 160 && item.solution.state == 2">授权该救援机构开始救援</li>
                  <li class="link" @click="toplook(item.bidding.id)" v-if="typeof item.solution != 'undefined'">报价详情</li>
                  <li class="link" @click="closeArr = item.solution.solutionNo; closeArr1 = props.row; expVisible1 = true; " v-if="props.row.dict.chkPt == 140 && (item.solution.state == 1 || item.solution.state == 0)">关闭报价</li>
                  <li @click="exptxt =item.stateText3;expVisible = true;" v-if="props.row.state == 160 && item.bidding.state == 2">授权说明</li>
                </ul>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{setTime(scope.row.obj.opStart)}}
        </template>
      </el-table-column>
      <el-table-column label="操作方">
        <template slot-scope="scope">
          {{scope.row.passport}}
        </template>
      </el-table-column>
      <el-table-column label="操作细节">
        <template slot-scope="scope">
          {{setTxt(scope.row.obj.opStateText)}}
        </template>
      </el-table-column>
     
      <el-table-column label="附件内容">
        <template slot-scope="scope">
         
          {{JSON.parse(scope.row.obj.extra).description}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button v-if="scope.row.obj.extraService != 105 && scope.row.obj.extraService != null" type="text" @click='showcooperaterDialogVisible=true;setData(scope.row.obj.extra,scope.row.obj.extraService,scope.row.obj.opPhotoUrls)'>查看内容</el-button>
          <el-button type="text" @click='goTo(scope.row)' :disabled='scope.$index != tableData.length - 1'>{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog class="dialog" title="查看详情" :visible.sync="showcooperaterDialogVisible" center width="700px"
      append-to-body>
      <div v-if="serviceId == 109">
        <p>内容：{{jbData.title}}</p>
        <p>详情：{{jbData.detail}}</p>
        <p v-if="opPhotoUrls">录音：
          <a v-for="item in opPhotoUrls" :href="item.url" :download="item.txt">{{item.txt}}</a>
        </p>
      </div>
      <div v-else-if="serviceId == 101 || serviceId == 102 ||serviceId == 103 ||serviceId == 104">
        <p> 加入/离开的人的姓名:{{jbData}}</p>
      </div>
      <div v-else-if='serviceId == 106'>
        <p>录像视频:</p>
        <a href="" download="录像视频">下载</a>
      </div>
      <div v-else-if='serviceId == 107'>
        <p>救助医院:{{jbData.hospital}}</p>
        <p>主治医师联系方式:{{jbData.contact}}</p>
        <p>主治医师名字:{{jbData.doctor}}</p>
      </div>
      <div v-else-if='serviceId == 108'>
        <p>描述:{{jbData.description}} </p>
        <a :href="jbData.url" download="下载">下载</a>
      </div>
      <div v-else-if='serviceId == 110'>
        <p>录音视频:</p>
        <a href="" download="录音视频">下载</a>
      </div>
      <div v-else-if='serviceId == 111'>
        <p>保险责任认定：{{jbData.chinese}} </p>
      </div>
      <div style="text-align: center;margin-top: 10px;">
        <el-button type="primary" @click='showcooperaterDialogVisible=false;'>确定</el-button>
        <el-button @click='showcooperaterDialogVisible=false;'>取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="确认关闭" :visible.sync="expVisible1" class="exp_dialog" width="300px" center>
      <p>是否确认关闭？</p>
    	<div style="text-align: center;margin-top: 20px;">
    		<el-button type='primary' @click=" reject(closeArr, closeArr1); expVisible1 = false;" > 确认</el-button>
    		<el-button type='primary' @click="expVisible1 = false">取消</el-button>
    	</div>
    </el-dialog>
    <el-dialog title="授权说明" :visible.sync="expVisible" class="exp_dialog" width="50%" center>
    	<p style="text-align:center">{{ exptxt }}</p>
    </el-dialog>
  </div>
</template>
 
<script>
  import {
    getCasedetail,
    caseProgress,
    listBidding,
    authorizeRescueStart,
    updateBiddingState,
    rescuecasefindrescueinsti
  } from '@/views/axios/api.js'
  import constants from '@/util/constants.js';
  export default {
    data() {
      return {
        Rescuecompany:'',
        inf: {},
        casenumber: "",
        showcooperaterDialogVisible: false,
        usertype: JSON.parse(window.localStorage.getItem("usertype")).data,
        token: JSON.parse(window.localStorage.getItem("data")).data,
        objdata: {},
        tableData: [],
        jbData: {},
        serviceId: '',
        opPhotoUrls: [],
        status2: [
          '未启动救援',
          '等待启动授权',
          '启动授权通过，待转交救援机构报价',
          '等待救援公司报价中',
          '已转交报价，等待监管授权',
          '报价授权通过，请开始救援',
          '开始救援中',
          '救援完成待确认',
          '救援完成',
          '分公司拒绝派单', //形式
          '总司调处拒绝派单',
          '等待分公司调处确认',
          '等待总公司调处确认',
          '进入正常流程，等待海外代表接入，或直接接单等后续流程'
        ],
        getRowKeys(row) {
          return row.obj.id;
        },
        expands: [],
        getBjLise:[],
        expVisible1:false,
        expVisible:false,
        exptxt:'',
        closeArr:'',
        closeArr1:''
      }
    },
    props: [
      'caseId1',
      'caseId',
      'type'
    ],
    methods: {
      toggleRowExpansion(row) {
        console.log(row);
        this.expands = [];
        this.expands.push(row.obj.id)
        this.getListBidding()
      },
      getListBidding(){
        listBidding({token:this.token,caseId:this.caseId})
        .then(res => {
          this.getBjLise=res.data.obj
        })
      },
      toplook(bidId) {
      	this.$router.push({
      		name: 'Comlookinf',
      		query: {
      			typeId: this.type,
      			caseid: this.caseId,
      			bidId
      		}
      	});
      },
      setTxt(str, status) {
        if (constants.setTxt(str, status)) {
          return constants.setTxt(str, status);
        } else {
          return str;
        }
      },
      setTime(str) {
        return constants.time(str)
      },
      setStatus(str) {
        return constants.ptXingshitxt3(str)
      },
      getData() {
        var data = {
          token: this.token,
          caseId: this.caseId || this.$route.query.caseid
        }
        rescuecasefindrescueinsti(data).then((res)=>{
          this.Rescuecompany = res.data.obj
          console.log(res)
        })
        caseProgress(data)
          .then(res => {
            console.log(res);
            this.tableData = res.data.obj.reverse();
            this.tableData.forEach(item => {
              let str = item.dict.chkPt
              let status = ''
              if (str == '100') {
                status = this.status2[0]
              } else if (str == '120') {
                status = this.status2[1]
              } else if (str == '130') {
                status = this.status2[2]
              } else if (str == '140') {
                status = this.status2[3]
              } else if (str == '150') {
                status = this.status2[4]
              } else if (str == '160') {
                status = this.status2[5]
              } else if (str == '180') {
                status = this.status2[6]
              } else if (str == '190') {
                status = this.status2[7]
              } else if (str == '110') {
                status = this.status2[8]
              } else if (str == '114') {
                status = this.status2[9]
              } else if (str == '115') {
                status = this.status2[10]
              } else if (str == '210') {
                status = this.status2[11]
              } else if (str == '211') {
                status = this.status2[12]
              } else if (str == '230') {
                status = this.status2[13]
              }
              item.name = status
            })
            console.log(this.tableData);
          })
          .catch(err => {
          
            console.log(err);
          })
      },
      setData(obj, id, arr) {
        if (id == 101 || id == 102 || id == 103 || id == 104) {
          this.jbData = obj
        } else {
          this.jbData = JSON.parse(obj)
        }

        this.serviceId = id;
        this.opPhotoUrls = JSON.parse(arr)
      },
      goTo(obj) {
        if (obj.dict.chkPt == 100) {
          this.$router.push({
            path: '/cmd_center/caseindex/helpStart',
            query: {
              typeId: this.type,
              caseid: this.caseId
            }
          })
        } else if (obj.dict.chkPt == 190) {
          this.$router.push({
            path: '/cmd_center/caseindex/resstep',
            query: {
              typeId: this.type,
              caseid: this.caseId,
              sure:1
            }
          })
        }
      },
      pass(){
        authorizeRescueStart({token:this.token,caseId:this.caseId})
        .then(res =>{
          if (res.data.code == 0) {
            	this.$message({
            		message: '操作成功',
            		type: 'success'
            	});
          }
        })
      },
      reject(solutionNo, v) {
          updateBiddingState({token: this.token,solutionNo,status: 2})
      		.then(res => {
      			if (res.data.code == 0) {
      				this.$message({
      					message: '操作成功',
      					type: 'success'
      				});
      				this.getData();
      			}
      		});
      },
    },

    mounted() {
      this.getData()
    },
    watch: {
      caseId() {
        this.getData()
      }
    }
  };
</script>


<style scoped>
  a {
    text-decoration: none;
    color: #00abfa;
  }

  .data_wrap {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .data_wrap h3 {
    font-size: 18px;
    color: #333;
    margin: 10px 0;
  }

  .data_wrap ul {
    width: 100%;
    overflow: hidden;
  }

  .data_wrap ul li {
    line-height: 40px;
    font-size: 16px;
    float: left;
    margin-right: 20px;
  }

  .data_wrap ul li:last-child textarea {
    width: 80%;
    height: 80px;
    border: 0;
    border: 1px solid #d9ddde;
    border-radius: 5px;
    font-size: 15px;
    margin-top: 15px;
  }

  .data_wrap ul li:last-child span,
  .data_wrap ul li:last-child textarea {
    float: left;
  }

  .req_box>p {
    margin-top: 15px;
    line-height: 45px;
    text-align: left;
  }

  .box_req ul li b {
    font-size: 14px;
  }

  .org_box {
    font-size: 16px;
    box-sizing: border-box;
    padding-left: 15px;
  }

  .org_box p {
    line-height: 40px;
    color: #333;
  }

  .acc_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .acc_box>p {
    color: #333;
    line-height: 40px;
    font-size: 15px;
  }

  .acc_box ul li {
    display: inline-block;
    width: 20%;
    text-align: center;
  }

  .acc_box ul li p {
    text-align: center;
    line-height: 36px;
    height: 36px;
    font-size: 14px;
  }

  .acc_box ul li img {
    width: 90px;
    height: 120px;
  }

  .rescue_box {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .rescue_box>p {
    line-height: 40px;
    font-size: 14px;
  }

  .res_div {
    position: relative;
    top: 18px;
  }

  .res_box {
    position: relative;
    top: 20px;
    font-size: 14px;
    color: #999;
  }

  .el-checkbox-group {
    position: relative;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .el-checkbox {
    width: 100%;
    margin-bottom: 20px;
  }

  .el-checkbox+.el-checkbox {
    margin-left: 0;
  }

  .db_div,
  .res_div {
    font-size: 14px;
    color: #333;
  }

  .db_box {
    font-size: 14px;
    color: #333;
    margin-left: 30px;
  }

  .db_box b {
    color: #ff7200;
    margin-left: 8px;
  }

  .upbtn_box {
    text-align: center;
    margin-top: 0;
  }

  .gl {
    overflow: hidden;
    margin-bottom: 20px;
  }

  .gl li {
    float: left;
    margin-right: 10px;
    line-height: 20px;
  }

  .margin {
    margin-bottom: 20px;
  }

  .dialog p {
    line-height: 2;
  }
  .baojia li{margin-right: 20px; display: inline-block;}
  .baojia span{color: #ff5500;}
  .link{color: #66b1ff;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/details/jianbao.vue